export default __webpack_public_path__ + "static/media/pie.679e0b9d.png";